import { writable } from "svelte/store";

export let clingoConfig = writable({
  base_url: "./clingo/asp",
  project: "project",
  models: 0,
  optimize: false,
});

export let recConfig = writable({
  preset: undefined,
  original_screen_type: undefined,
  original_screen: undefined,
  original_orient: undefined,
  intended_screen_type: undefined,
  intended_screen: undefined,
  intended_orient: undefined,
  artboard_width: undefined,
  artboard_height: undefined,
  specname: undefined,
  title: undefined,
  keep_aspect_ratio: undefined,
  allow_filter: false,
  data_filter: undefined,
  data_filter_expr: "",
  n_big_models: 7,
  n_small_models: 1,
  randomize: false,
  p_drastic: 0.6
});


export function updateClingoConfig(key, value) {
  clingoConfig.update(c => {
    c[key] = value;
    return c;
  });
}

export function updateRecConfig(key, value) {
  recConfig.update(c => {
    c[key] = value;
    return c;
  });
}

export function makeLLTConstraints(stack) {
  return stack.map((item) => {
    if (item.uncommons.length > 0) {
      return `illegal(user,"${item.stack_id}") :- ` + item.uncommons.map((d) => d.trim().replace(/\.$/, "")).join(", ") + ".";
    } else {
      // only those
      return `illegal(user,"${item.stack_id}") :- ` + item.strategies.map((d) => d.trim().replace(/\.$/, "")).join(", ")
        + ", C1 = { strategy(_,_) }, C2 = { adjunct(_,_,_) }, "
        + `${item.strategies.length} == C1 + C2.`;
    }
  });
}

export function makeMLTConstraints(stack) {
  return stack.map((item, i) => {
    return `illegal(user,mlt_r${i}) :- ` +
      `${item.length} == C1 + C2, ` +
      "C1 = { strategy(_,_) }, C2 = { adjunct(_,_,_) }, " +
      item.map((d) => d.trim().replace(/\.$/, "")).join(", ") + ".";
  });
}